import { Form, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSTextArea from 'components/CIMSTextArea'

const PendingResponseFormItems: React.FC = () => {
  return (
    <>
      <Form.Item hidden name="action" initialValue="respond">
        <Input />
      </Form.Item>
      <CIMSFormItem
        name="response"
        label="Response"
        requiredMessage
        help={HelpMessage.Issues.IssueTracker.Response}
      >
        <CIMSTextArea maxLength={2000} />
      </CIMSFormItem>
    </>
  )
}

export default PendingResponseFormItems
